import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable max-len */
import React from 'react';
export function ErrorIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.5 22.6562C18.1091 22.6562 22.6562 18.1091 22.6562 12.5C22.6562 6.89086 18.1091 2.34375 12.5 2.34375C6.89086 2.34375 2.34375 6.89086 2.34375 12.5C2.34375 18.1091 6.89086 22.6562 12.5 22.6562Z",
      fill: "#FF4954"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.2059 12.5L16.7645 9.94139C17.0785 9.62741 17.0785 9.11835 16.7645 8.80412L16.1959 8.23548C15.8819 7.92151 15.3728 7.92151 15.0586 8.23548L12.5 10.7941L9.94139 8.23548C9.62741 7.92151 9.11835 7.92151 8.80412 8.23548L8.23548 8.80412C7.92151 9.1181 7.92151 9.62716 8.23548 9.94139L10.7941 12.5L8.23548 15.0586C7.92151 15.3726 7.92151 15.8816 8.23548 16.1959L8.80412 16.7645C9.1181 17.0785 9.62741 17.0785 9.94139 16.7645L12.5 14.2059L15.0586 16.7645C15.3726 17.0785 15.8819 17.0785 16.1959 16.7645L16.7645 16.1959C17.0785 15.8819 17.0785 15.3728 16.7645 15.0586L14.2059 12.5Z",
      fill: "white"
    })]
  });
}